var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.88623 9C1.59161 5.15982 4.95609 2.25 9.00023 2.25C13.0443 2.25 16.4088 5.15982 17.1142 9C16.4088 12.8401 13.0443 15.75 9.00023 15.75C4.95609 15.75 1.59161 12.8401 0.88623 9ZM9.00023 12.75C11.0713 12.75 12.7502 11.071 12.7502 9C12.7502 6.92894 11.0713 5.25 9.00023 5.25C6.92913 5.25 5.2502 6.92894 5.2502 9C5.2502 11.071 6.92913 12.75 9.00023 12.75ZM9.00023 11.25C7.75755 11.25 6.7502 10.2427 6.7502 9C6.7502 7.75733 7.75755 6.75 9.00023 6.75C10.2428 6.75 11.2502 7.75733 11.2502 9C11.2502 10.2427 10.2428 11.25 9.00023 11.25Z",
    fill: "#696969"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeFill);
export default __webpack_public_path__ + "static/media/eye-fill.f107b8b706527e1611acfe9e96c809d1.svg";
export { ForwardRef as ReactComponent };